import * as React from 'react';
import * as qs from 'query-string';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchPendingAction } from "../../global/middleware/fetch-middleware";
import { IEpiProps } from '../state-helpers/epi-props';
import { IBaseAppState } from '..';
import { getEpiProps } from '../../global/ducks/epi-api';
import { IFilterableListCriteria, IFilterableListFacetTerm, IFilterableListResultsDto, INameAndEmailRequest, IFilterableListFacet } from '../../global/dtos/filterable-list-results-dto';
import { getResults, resetGetResultsCallerFlag, saveNameAndEmail } from '../../global/ducks/filterable-list-api';
import { FilterableListResult } from './filterable-list-result';
import { ConnectedSearchBar } from '../../global/components/inputs/search-bar/search-bar';
import { pushInUrlQuery, multiPushInUrlQuery } from 'react-url-query';
import { FilterableListFacets } from './filterable-list-facets';
import { setUrlFacets, setUrlPage } from '../../global/actions/filter-actions';
import { IPaginationOptions, Pagination } from '../../global/components/pagination/pagination';
import { SortGroup } from '../../global/components/inputs/sort/sort';
import { GetSorts } from '../state-helpers/sorts';
import { IGlobalSort } from '../../global/state-helpers/sort';
import { debounce, isEmpty } from 'lodash';
import { NoResults } from './no-results';
import { RestrictedContentInputs } from '../../global/components/inputs/restrictedContentForm/restricted-content-inputs';

const PageSize = 20;
const enum FilterableListCallers {
    GetResults= 'filterableList/getResults'
}

interface IStateProps {
    epiProps: IEpiProps,
    results: IFilterableListResultsDto,
    uniqueUserId: string;
    getResultsAsyncCaller: string;
}

interface IDispatchProps {
    getEpiProps: () => FetchPendingAction;
    getResults: (criteria: IFilterableListCriteria, asyncCaller?: string) => FetchPendingAction;
    saveNameAndEmail: (request: INameAndEmailRequest) => FetchPendingAction;
    resetGetResultsFlag: (asyncCaller?: string) => FetchPendingAction;
}

interface IOwnProps {
    contentId: string;
    pageTitle: string;
    requireNameAndEmail: boolean;
    name: string;
    email: string;
    uniqueUserIdBootstrap: string;
    gridclass: string;
}

type IProps = IStateProps & IDispatchProps & IOwnProps;

interface IQueryProps {
    k?: string;
    page?: string;
    facets?: string;
    sortField?: string;
    sortDirection?: string;
}

interface IState {
    searchText: string;
    pageSize: number;
    pageNumber: number;
    facets: IFilterableListFacet[];
    loading: boolean,
    results: IFilterableListResultsDto;
    sortField: string;
    sortDirection: number;

    allowedSortFields: string[];
    columnOrder: string[];

    showNameAndEmailInputs: boolean;
    name: string;
    email: string;
    uniqueUserId: string;
}

const ComponentId = 'filterable-list-component';
class FilterableListPageApp extends React.Component<IProps, IState> {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            searchText: "",
            pageSize: PageSize,
            pageNumber: 1,
            facets: [],
            results: null,

            sortField: null,
            sortDirection: 0,
            allowedSortFields: [],
            columnOrder: [],

            showNameAndEmailInputs: this.props.requireNameAndEmail
                && ((!this.props.name || this.props.name == "")
                || (!this.props.email || this.props.email == "")),
            name: this.props.name,
            email: this.props.email,
            uniqueUserId: this.props.uniqueUserIdBootstrap
        }

    }

    componentDidMount() {
        this.parseQuery()
            .then(() => {
                return this.props.getEpiProps().fetch
            })
            .then(() => {
                return this.getResults();
            });
    }

    componentDidUpdate(prevState, prevProps) {
        if (prevProps.results !== this.props.results && this.props.getResultsAsyncCaller === FilterableListCallers.GetResults) {
            this.setState({
                        loading: false,
                        results: this.props.results,
                        facets: this.props.results.facets,
                        allowedSortFields: this.props.results.allowedSortFields,
                        columnOrder: this.props.results.columnOrder,
            });
            if (this.props.results && this.props.results.allowedSortFields && this.props.results.allowedSortFields.length > 0) {
                localStorage.setItem('allowedSorts', JSON.stringify(this.props.results.allowedSortFields));
            }
            this.props.resetGetResultsFlag();
        }
    }

    render() {
        const { epiProps } = this.props;
        const { results, loading, allowedSortFields,
            showNameAndEmailInputs, } = this.state;

        const pagination = {
            totalItems: results ? results.totalNumber : 0,
            currentPage: this.state.pageNumber,
            pageSize: PageSize,
        } as IPaginationOptions;
        let gridstyle = "repeat(auto-fit, minmax(250px, 1fr))";
        if (!isEmpty(this.props.gridclass)) {
            gridstyle = this.props.gridclass.replace(/\s+/g, "").split(",").join("fr ") + "fr";
        }
        return (
            <React.Fragment>
                {loading && !showNameAndEmailInputs &&
                    <div>
                        Loading...
                    </div>
                }

                {showNameAndEmailInputs ?
                    <div className="row">
                        <RestrictedContentInputs
                            formTitle={this.props.epiProps.nameAndEmailFormTitle}
                            nameInputLabel={this.props.epiProps.nameInputLabel}
                            namePlaceholder={this.props.epiProps.namePlaceholder}
                            emailInputLabel={this.props.epiProps.emailInputLabel}
                            emailPlaceholder={this.props.epiProps.emailPlaceholder}
                            nameRequiredError={this.props.epiProps.nameRequiredError}
                            emailRequiredError={this.props.epiProps.emailRequiredError}
                            emailInvalidError={this.props.epiProps.emailInvalidError}
                            submitCtaText={this.props.epiProps.submitCtaText}
                            setNameAndEmail={(name: string, email: string) => this.setFilterablePageNameAndEmail(name, email)}
                        />
                        </div> :

                    <div className="filterable-list-container" id={ComponentId}>

                        <div className="desktop-facets-wrapper">
                            {this.renderFacets(false)}
                        </div>

                        <div className={`filterable-list-content ${!isEmpty(this.props.gridclass) ? "grid" : ""}`} style={{ "--grid-cols": gridstyle } as React.CSSProperties}>
                            <ConnectedSearchBar
                                onSearch={this.onSearch}
                                onChange={this.onSearchChange}
                                searchValue={this.state.searchText}
                                defaultValue={this.queryProps.k}
                                searchButtonText="Search"
                                customClasses={"filterable-list-search no-scroll"}
                                id={"filterable-list-search-bar"}
                                setOpen={true}
                            />

                            <div className="mobile-facets-wrapper">
                                {this.renderFacets(true)}
                            </div>

                            {results && results.columnNames && results.columnNames.length > 0 && results.totalNumber > 0 &&
                                <SortGroup
                                    sortGroupName='sorts'
                                    sorts={this.filterableListSorts}
                                    onSort={(sort: IGlobalSort<IFilterableListResultsDto>) => this.onSortSelect(sort.sortId)}
                                    twoDimensional={true}
                                    activeSortDirection={this.state.sortDirection}
                                />
                            }

                            {this.renderResults()}

                            <Pagination
                                pagination={pagination}
                                onPageSelect={this.setPage}
                                useRedux={true}
                            />

                        </div>
                    </div>

                }
            </React.Fragment>
        );
    }

    renderResults = () => {
        const { results, loading, allowedSortFields, pageNumber, pageSize } = this.state;

        if (loading || !results) return null;

        if (results.totalNumber == 0) return (
            <div className="filterable-list-results">
                    <NoResults epiProps={this.props.epiProps} />
            </div>
            );

        let start = (pageNumber - 1) * pageSize;
        let paginatedResults = results.searchItemList.slice(start, start + pageSize);

        return (
            <div className="filterable-list-results">
                {paginatedResults.map((result, i) =>
                    <FilterableListResult
                        columnNames={results.columnNames}
                        columnOrder={this.state.columnOrder}
                        result={result} key={i}
                        itemNumber={i + 1}
                        pageTitle={this.props.pageTitle}
                        guestName={this.state.name}
                        guestEmail={this.state.email}
                        guestUniqueId={this.state.uniqueUserId}
                    />
                )}
            </div>
        );

    }

    get queryProps(): IQueryProps {
        return qs.parse(window.location.search)
    }

    get filterableListSorts() {
        const { results, sortField } = this.state;

        let inactiveSorts = results.columnNames.filter(c => !results.allowedSortFields.some(x => x.toLowerCase() === c.toLowerCase()));

        return GetSorts(results.columnNames, this.state.sortField, inactiveSorts);
    }

    renderFacets = (isMobile: boolean) => {
        const { results } = this.state;
        const { epiProps } = this.props;

        if (results && results.facets.length > 0) {
            return (
                results && results.facets.length > 0 &&
                <FilterableListFacets
                    facets={this.state.facets}
                    onUpdateFacet={this.setFacets}
                    facetsResetLinkText={epiProps.filterResetText}
                    filterHeaderText={epiProps.filterHeaderText}
                    isMobile={isMobile}
                />
            );
        }
    }

    saveNameAndEmail = (name: string, email: string) => {
        this.props.saveNameAndEmail({
            name: name,
            email: email,
        } as INameAndEmailRequest).fetch
            .then(() => {
                this.setState({
                    uniqueUserId: this.props.uniqueUserId
                });
            });
    }

    getResults = () => {
        this.setState({
            loading: true
        }, () => {
            this.props.getResults({
                pageId: parseInt(this.props.contentId),
                searchTerm: this.state.searchText,
                pageSize: this.state.pageSize,
                page: this.state.pageNumber,
                facets: this.state.facets,
                sortField: this.state.sortField,
                sortDirection: this.state.sortDirection ? this.state.sortDirection : 0,
                allowedSortFields: this.state.allowedSortFields.length > 0 ? this.state.allowedSortFields : JSON.parse(localStorage.getItem('allowedSorts')),
            } as IFilterableListCriteria, FilterableListCallers.GetResults).fetch;
        })
    }

    onSearch = (searchText: string) => {
        this.setFacets([]);
        pushInUrlQuery('k', searchText);
    }

    onSearchDebounced = debounce((searchText: string) => {
        this.onSearch(searchText);
    }, 500);

    onSearchChange = (searchText: string) => {
        this.setState({
            searchText,
        });

        this.onSearchDebounced(searchText);
    }

    setPage = (pageNumber: number) => {
        if (pageNumber === this.state.pageNumber) return;

        setUrlPage(pageNumber);
        this.setState({
            pageNumber
        });

        document.getElementById(ComponentId).scrollIntoView();
    }

    setUrlPage = (pageNumber: number) => {
        pushInUrlQuery('page', pageNumber);
    }

    setFacets = (facets: IFilterableListFacet[]) => {
        let pageNumber = 1;

        setUrlPage(pageNumber);
        setUrlFacets(facets);
        this.setState(
            {
                pageNumber,
                facets
            },
            () => this.getResults()
        );
    }

    onSortSelect = (sortField: string) => {
        let sortDirection = 0
        if (sortField === this.state.sortField) {
            // toggle 0 or 1 (descending vs ascending)
            sortDirection = 1 - this.state.sortDirection;
        }

        let pageNumber = 1;

        multiPushInUrlQuery({
            sortField: sortField,
            page: pageNumber,
            sortDirection
        });

        this.setState({
            pageNumber,
            sortField,
            sortDirection,
        }, () => this.getResults());
    }

    parseQuery = () => {
        return new Promise<void>((resolve, reject) => {
            let searchText = this.state.searchText;
            let pageNumber = this.state.pageNumber;
            let facets = this.state.facets;
            let sortField = this.state.sortField;
            let sortDirection = this.state.sortDirection;

            const { queryProps } = this;
            if (queryProps.k) {
                searchText = queryProps.k;
            }
            if (queryProps.page) {
                pageNumber = parseInt(queryProps.page);
            }

            if (queryProps.sortField) {
                sortField = queryProps.sortField;
            }

            if (queryProps.sortDirection) {
                sortDirection = queryProps.sortDirection ? parseInt(queryProps.sortDirection) : 0;
            }

            if (queryProps.facets) {
                facets = JSON.parse(queryProps.facets).map(facet => ({
                    fieldName: facet.fieldName,
                    terms: facet.terms.map(term => ({
                        term: term.term,
                        selected: true
                    }))
                }));
            }

            this.setState({
                searchText,
                pageNumber,
                facets,
                sortField,
                sortDirection,
            }, () => { resolve() })
        });
    }

    setFilterablePageNameAndEmail = (name: string, email: string) => {
        this.setState({
            showNameAndEmailInputs: false,
            name: name,
            email: email
        });
        this.saveNameAndEmail(name, email);
    }

}

const mapStateToProps = (state: IBaseAppState): IStateProps => ({
    epiProps: state.epi.props,
    results: state.results.results,
    uniqueUserId: state.results.uniqueUserId,
    getResultsAsyncCaller: state.results.getResultsAsyncCaller
})

const mapDispatchToProps = (dispatch, ownProps: IOwnProps): IDispatchProps => bindActionCreators({
    getEpiProps: () => getEpiProps(ownProps.contentId) as any,
    getResults: getResults as any,
    saveNameAndEmail: saveNameAndEmail as any,
    resetGetResultsFlag: resetGetResultsCallerFlag as any,
}, dispatch)

export const FilterableListApp = connect<IStateProps, IDispatchProps, IOwnProps>(mapStateToProps, mapDispatchToProps)(FilterableListPageApp);
